import Vue from 'vue'
import Router from 'vue-router'
import NProgress from "nprogress";
import "nprogress/nprogress.css";
NProgress.configure({ showSpinner: false });

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/view/index')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/view/login')
    },
    {
      path: '/invitation',
      name: 'invitation',
      component: () => import('@/view/invitation')
    },
    {
      path: '/projectItem',
      name: 'projectItem',
      component: () => import('@/view/projectItem')
    },
    {
      path: '/projectItemApply',
      name: 'projectItemApply',
      component: () => import('@/view/projectItemApply')
    },
    {
      path: '/letter',
      name: 'letter',
      component: () => import('@/view/letter')
    },
    {
      path: '/contract',
      name: 'contract',
      component: () => import('@/view/contract')
    },
    {
      path: '/pair',
      name: 'pair',
      component: () => import('@/view/pair')
    },
    {
      path: '/feeling',
      name: 'feeling',
      component: () => import('@/view/feeling')
    },
    {
      path: '/growup',
      name: 'growup',
      component: () => import('@/view/growup')
    },
    {
      path: '/growupone',
      name: 'growupone',
      component: () => import('@/view/growupone')
    },
    {
      path: '/graduationGo',
      name: 'graduationGo',
      component: () => import('@/view/graduationGo')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/view/home')
    },
    {
      path: '/familyMember',
      name: 'familyMember',
      component: () => import('@/view/familyMember')
    },
    {
      path: '/familyInfo',
      name: 'familyInfo',
      component: () => import('@/view/familyInfo'),
    },
    {
      path: '/basicInfo',
      name: 'basicInfo',
      component: () => import('@/view/basicInfo'),
    },
    {
      path: '/projectList',
      name: 'projectList',
      component: () => import('@/view/projectList'),
    }
  ]
})

router.beforeEach(function (to,from,next){
  NProgress.start();
  next();
})

router.afterEach(function (){
  NProgress.done();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js